import axios from 'axios';
import { appConfig } from '../../../../tools/AppConfig';

const COUNTRY_URL = appConfig.getServerUrl();

export const checkData = (
  token,
  phone,
  pin,
  integrationId,
  amount
) => {
  return axios
    .post(`${COUNTRY_URL}/api/acceptance/souhoola/check_data`, {
      payment_token: token,
      phone_number: phone.slice(2, phone.length),
      pin: pin,
      integration_id: integrationId,
      amount_cents: amount,
      accept_lang: 1,
    })
    .then((res) => res)
    .catch((err) => err.response);
};

export const tenureInquiry = (
    token,
    downPayment,
    souhoolaToken,
    integration_id
  ) => {
    return axios
      .post(`${COUNTRY_URL}/invoice2/${token}`, {
        source: {
            identifier: souhoolaToken,
            subtype: 'SOUHOOLAV2_ONLINE',
            down_payment: downPayment * 100,
            accept_language: 'EN',
          },
          token: token,
          integration_id
      })
      .then((res) => res)
      .catch((err) => err.response);
  };
  
export const changeInstallment = (
    reference,
    downPayment,
    paymentToken
  ) => {
    return axios
      .post(`${COUNTRY_URL}/api/acceptance/souhoola/change_installment`, {
        "referance": reference,
        "down_payment": downPayment*100,
        "payment_token": paymentToken,
        "accept_lang": 0
      })
      .then((res) => res)
      .catch((err) => err.response);
  };

  export const installmentReview = (
    token,
    months,
    downPayment,
    reference,
    amount
  ) => {
    return axios
      .post(`${COUNTRY_URL}/api/acceptance/souhoola/installment_review`, {
        referance: reference,
        maxMonths: months,
        loanAmount: amount,
        downPayment: downPayment,
        payment_token: token,
        promoCode: 'M',
      })
      .then((res) => res)
      .catch((err) => err.response);
  };
  export const confirmInstallment = (
    token,
    souhoolaId,
    reference
  ) => {
    return axios
      .post(`${COUNTRY_URL}/api/acceptance/souhoola/confirm_installment`, {
        referance: reference,
        souhoola_id: souhoolaId,
        payment_token: token,
        accept_lang: 1,
      })
      .then((res) => res)
      .catch((err) => err.response);
  };
  export const confirmTransaction = (
    otp,
    token,
    transactionId
  ) => {
    return axios
      .post(`${COUNTRY_URL}/api/acceptance/souhoola/confirm_transaction`, {
        otp: otp,
        payment_token: token,
        transaction_id: transactionId,
      })
      .then((res) => res)
      .catch((err) => err.response);
  };
  
  export const resendOtp = (token, reference) => {
    return axios
      .post(`${COUNTRY_URL}/api/acceptance/souhoola/resend_otp`, {
        payment_token: token,
        referance: reference,
        accept_lang: 1,
      })
      .then((res) => res)
      .catch((err) => err.response);
  };
  
  
  